/**
 * Membership Advice Section
 * Scroll-triggered fade animation for the dot-line connector and cards.
 * Dynamic connector-line positioning so the line spans from the first
 * dot center to the last dot center.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.membership-advice[data-animate="true"]';
  var VISIBLE_CLASS = 'membership-advice--visible';
  var DESIGN_MODE_CLASS = 'membership-advice--design-mode';

  /* ------------------------------------------------
   * Position the connector line so it starts at the
   * vertical center of the first dot and ends at the
   * vertical center of the last dot.
   * ------------------------------------------------ */
  function positionConnectorLines(rootEl) {
    var containers = (rootEl || document).querySelectorAll('.membership-advice__cards');
    containers.forEach(function (cards) {
      var dots = cards.querySelectorAll('.membership-advice__card-dot');
      var line = cards.querySelector('.membership-advice__connector-line');
      if (!line || dots.length < 2) return;

      var firstDot = dots[0];
      var lastDot  = dots[dots.length - 1];

      // offsetTop is relative to the offsetParent. Both dots live inside
      // their respective cards which are children of .membership-advice__cards.
      // Because the dot is position:absolute inside the card, its offsetParent
      // is the card. We need the position relative to the cards container.
      var firstDotCenter = firstDot.offsetParent.offsetTop + firstDot.offsetTop + firstDot.offsetHeight / 2;
      var lastDotCenter  = lastDot.offsetParent.offsetTop  + lastDot.offsetTop  + lastDot.offsetHeight / 2;

      line.style.top    = firstDotCenter + 'px';
      line.style.height = (lastDotCenter - firstDotCenter) + 'px';
      line.style.bottom = 'auto';
    });
  }

  /* Debounce helper */
  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      positionConnectorLines();
    }, 150);
  }

  /* ------------------------------------------------
   * Scroll-triggered animation
   * ------------------------------------------------ */
  function initMembershipAdviceAnimation(rootEl) {
    var sections = (rootEl || document).querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;

    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach(function (section) {
        section.classList.add(VISIBLE_CLASS);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add(VISIBLE_CLASS);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: window.innerWidth < 750 ? '0px 0px -80px 0px' : '0px 0px -120px 0px',
        threshold: window.innerWidth < 750 ? 0.1 : 0.15,
      }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function initDesignMode(rootEl) {
    var sections = (rootEl || document).querySelectorAll(SECTION_SELECTOR);
    sections.forEach(function (section) {
      section.classList.add(DESIGN_MODE_CLASS);
      section.classList.add(VISIBLE_CLASS);
    });
    positionConnectorLines(rootEl);
  }

  /* ------------------------------------------------
   * Bootstrap
   * ------------------------------------------------ */
  function init() {
    initMembershipAdviceAnimation();
    positionConnectorLines();
    window.addEventListener('resize', onResize);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify design mode support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initDesignMode(event.target);
    });
    document.addEventListener('shopify:section:reorder', function () {
      initDesignMode(document);
    });
  }
})();
